import React from 'react'
import PropTypes from 'prop-types'
import {Button} from 'rambler-ui'
import Popup from 'components/Popup'

export default function DeleteContact({
  contact,
  onResolve,
  onReject,
  cerberId,
  ...props
}) {
  const isEmail = /@/.test(contact)

  const content = isEmail
    ? `Вы готовы удалить электронную почту ${contact} из списка адресов?`
    : `Вы готовы удалить телефонный номер ${contact} из списка номеров?`

  return (
    <Popup
      {...props}
      title={`Удаление ${isEmail ? 'почты' : 'номера'}`}
      okButton={
        <Button type="primary" onClick={onReject}>
          Не удалять
        </Button>
      }
      cancelButton={
        <Button
          type="outline"
          onClick={onResolve}
          data-cerber-id={cerberId('profile::')}
        >
          Удалить
        </Button>
      }
    >
      {content}
    </Popup>
  )
}

DeleteContact.propTypes = {
  contact: PropTypes.string,
  onResolve: PropTypes.func,
  onReject: PropTypes.func,
  cerberId: PropTypes.func
}
